import { Component, Inject, ChangeDetectorRef, ElementRef, ComponentFactoryResolver } from '@angular/core';
import { AroService } from '@core_n/aro/aro.service';
import { AroPlotCoreComponent } from '@core_n/aro/aro-plot-core.component';
import * as utils from '@core_n/common/utils';
import * as units from '@core_n/common/units';
import * as aro from '@core_n/aro/aro';
import { PlotObject } from '../asp/PlotObject';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: '../../core/app/aro/aro-plot-core.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss']
})
export class AroPlotComponent extends AroPlotCoreComponent {

  // public range: string;
  // public rangeUnits: string;
  // public azimuth: string;
  // public elevation: string;
  // public doppler: string;
  // public dopplerAccuracy: string;
  // public dopplerUnits: string;
  // public spinRate: string;
  // public maneuver: string;

  // constructor(
  //   aroService: AroService, 
  //   cdref: ChangeDetectorRef) 
  //   {
  //   super(aroService, cdref);
  //   this.extraDataNumRows = 2;
  //   this.extraDataNumColumns = 4;
  // }

  constructor(public dialogRef: MatDialogRef<AroPlotComponent>,
    //private userActionSrv: UserActionService,
    elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
    aroService: AroService, 
    cdref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver) 
    {
    super(aroService, cdref, elementRef, dialogRef);
    this.extraDataNumRows = 3;
    this.extraDataNumColumns = 3;
  }
  
  protected refresh(): void {
    super.refresh();
    // if (this.shown && this.plot != null) {
    //   let plot = this.plot as PlotObject;
    //   this.range = typeof plot.range == 'undefined' ? aro.NO_VALUE : units.distanceValue(plot.range, 1);
    //   this.rangeUnits = units.distanceUnits();
    //   this.doppler = typeof plot.doppler == 'undefined' ? aro.NO_VALUE : units.speedValue(plot.doppler, 2);
    //   this.dopplerAccuracy = typeof plot.dopplerAccuracy == 'undefined' ? aro.NO_VALUE : units.speedValue(plot.dopplerAccuracy, 2);
    //   this.dopplerUnits = units.speedUnits();
    //   this.spinRate = typeof plot.spinRate == 'undefined' ? aro.NO_VALUE : plot.spinRate.toFixed(2);
    //   this.maneuver = aro.boolToStr(plot.inManeuver);
    // }
    // this.range = (this.plot.range).toString();
    // this.azimuth = (this.plot.azimuth * units.RAD_TO_DEG).toFixed(3).toString();
    // this.elevation = (this.plot.elevation * units.RAD_TO_DEG).toFixed(3).toString();
  }

  protected onShowAro() {
    // this.azimuth = typeof this.plot.azimuth == 'undefined' ?
    //   aro.NO_VALUE : units.headingValue(this.plot.azimuth);
    // this.elevation = typeof this.plot.elevation == 'undefined' ?
    //   aro.NO_VALUE : (this.plot.elevation * units.RAD_TO_DEG).toFixed(1);
  }

  // extraDataLabel(row: number, column: number) {
  //   if (row == 0) {
  //     switch (column) {
  //       case 0:
  //         return 'RANGE';
  //       case 1:
  //         return 'AZIMIUTH';
  //       case 2:
  //         return 'ELEVATION';
  //       case 3:
  //         return 'MANEUVER';
  //     }
  //   }
  //   else if (row == 1) {
  //     switch (column) {
  //       case 0:
  //         return 'DOPPLER';
  //       case 1:
  //         return 'DOPPLER ACC.';
  //       case 2:
  //         return 'SPIN RATE';
  //     }
  //   }
  // }

  // extraDataUnits(row: number, column: number) {
  //   if (row == 0) {
  //     switch (column) {
  //       case 0: // Range
  //         return ` ${this.rangeUnits}`;
  //       case 1: // Azimuth
  //         return units.DEGREE_CHAR;
  //       case 2: // Elevation
  //         return units.DEGREE_CHAR;
  //     }
  //   }
  //   else if (row == 1) {
  //     switch (column) {
  //       case 0: // Doppler
  //         return ` ${this.dopplerUnits}`;
  //       case 1: // Doppler accuracy
  //         return ` ${this.dopplerUnits}`;
  //       case 2: // Spin Rate
  //         return ` Hz`;
  //     }
  //   }
  // }

  // extraDataValue(row: number, column: number) {
  //   if (row == 0) {
  //     switch (column) {
  //       case 0:
  //         return this.range;
  //       case 1:
  //         return this.azimuth;
  //       case 2:
  //         return this.elevation;
  //       case 3:
  //         return this.maneuver;
  //     }
  //   }
  //   else if (row == 1) {
  //     switch (column) {
  //       case 0:
  //         return this.doppler;
  //       case 1:
  //         return this.dopplerAccuracy;
  //       case 2:
  //         return this.spinRate;
  //     }
  //   }
  // }


  setPlot(plot: PlotObject) {
    this.plot = plot;
    this.shown = true;
    this.refresh();
  }

  static createDialogConfig(plot: PlotObject) {
    let dialogConfig = utils.createDialogConfig(false);
    dialogConfig.data = { plot: plot };
    return dialogConfig;
  }
}
